// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","paper":"paper-2F3Si","modal":"modal-18_i0"};